import { call, takeEvery } from 'redux-saga/effects';
import frameActions from '@/constants/frames';
import { postMessage } from '@/utils/sagaHelper';
import { responseCode, responseMessage } from '@/utils/errors';
import { workspaceActions, workspaceFormActions } from '../constants';

export function* destroyRequestWorkspaceMessage({ code }) {
  yield call(postMessage, { type: frameActions.FRAME_WORKSPACE_CANCELLED, code });
}

export function* requestWorkspaceSuccessMessage({ code, result }) {
  yield call(postMessage, { type: frameActions.FRAME_WORKSPACE_REQUESTED, code, receipt: result.markdown });
}

export function* showWorkspaceFormHealthError({ code, source }) {
  yield call(postMessage, { type: frameActions.FRAME_WORKSPACE_FORM_HEALTH_ERROR, code, from: source });
}

export function* requestWorkspaceErrorMessage(action) {
  const errorCode = responseCode(action);
  const errorMessage = responseMessage(action);
  yield call(postMessage, {
    type: frameActions.FRAME_WORKSPACE_REQUESTED_ERROR,
    code: action.code,
    errorCode,
    errorMessage,
  });
}

export default function* workspaceFrameMessages() {
  yield takeEvery(workspaceActions.DESTROY_REQUEST_WORKSPACE, destroyRequestWorkspaceMessage);
  yield takeEvery(workspaceActions.REQUEST_WORKSPACE_ERROR, requestWorkspaceErrorMessage);
  yield takeEvery(workspaceActions.REQUEST_WORKSPACE_SUCCESS, requestWorkspaceSuccessMessage);
  yield takeEvery(workspaceFormActions.SHOW_WORKSPACE_FORM_HEALTH_ERROR, showWorkspaceFormHealthError);
}
